export default function PHP_OOPConstants() {
  return (
    <div>
      <h1>PHP_OOPConstants</h1>
    </div>
  );
}
